import { platform } from "~/platform/socket";
import FaqCatalogGQL from "../graphql/catalog.gql?raw";
import type { FaqCatalog } from "../types";

export async function fetchFaq(id: string): Promise<FaqCatalog> {
	const { faqCatalog } = await platform.query<{ faqCatalog: FaqCatalog }>(FaqCatalogGQL, { id: id });
	return {
		...faqCatalog,
		categories: faqCatalog.categories.filter((category) => category.articles.length > 0),
	};
}
